import React, { useEffect, useMemo } from 'react'
import TagManager from 'react-gtm-module'
import { useEthers } from './hooks'
import { Switch, Route, Redirect, useLocation } from 'react-router-dom'
import { LoadingPage } from './pages/LoadingPage'
import { CountryBlocker } from './pages/CountryBlocker'
import { Swap } from './pages/swap/Swap'
import { Pool } from './pages/pool/Pool'
import { AddLiquidity } from './pages/addLiquidity/AddLiquidity'
import { RemoveLiquidity } from './pages/removeLiquidity/RemoveLiquidity'
import { Maintenance, SHOW_MAINTENANCE } from './pages/Maintenance'
import { Token } from './pages/token/Token'
import { initAmplitude, logAmplitudeEvent, setAmplitudeUserProperties } from './utils'
import { ComplianceModal, Header, HelpButton } from './common'
import { useApiIsValidCountry } from './providers/apiIsValidCountry/useApiIsValidCountry'
import { useApiBlacklistedWallets } from './providers/apiBlacklistedWallets/useApiBlacklistedWallets'
import { BlacklistedWalletBlocker } from './pages/BlacklistedWalletBlocker'

// Google Tag Manager
const tagManagerArgs = {
  gtmId: 'GTM-WDK5ZP4',
}
TagManager.initialize(tagManagerArgs)

// Amplitude
initAmplitude()

export function App() {
  const isValidCountry = useApiIsValidCountry()

  const location = useLocation()
  useEffect(() => {
    logAmplitudeEvent(`Page View: ${location.pathname}`)
  }, [location])

  const { account, chainId } = useEthers()

  useEffect(() => {
    logAmplitudeEvent('Wallet: Change Address', { address: account })
    setAmplitudeUserProperties({ address: account })
  }, [account])

  useEffect(() => {
    logAmplitudeEvent('Wallet: Change Chain', { chainId })
    setAmplitudeUserProperties({ chainId })
  }, [chainId])

  const blacklistedWallets = useApiBlacklistedWallets()
  const isWalletBlacklisted = useMemo(() => {
    return account && blacklistedWallets && blacklistedWallets.includes(account.toLowerCase())
  }, [account, blacklistedWallets])

  if (isValidCountry === undefined) {
    return (
      <>
        <Header />
        <LoadingPage />
      </>
    )
  } else if (!isValidCountry) {
    return (
      <>
        <Header />
        <CountryBlocker />
      </>
    )
  } else if (isWalletBlacklisted) {
    return (
      <>
        <Header />
        <BlacklistedWalletBlocker />
      </>
    )
  } else if (SHOW_MAINTENANCE) {
    return (
      <>
        <Header />
        <HelpButton />
        <Maintenance />
      </>
    )
  } else {
    return (
      <>
        <Header />
        <HelpButton />
        <ComplianceModal />
        <Switch>
          <Route exact path="/swap" component={Swap} />
          <Route exact path="/withdraw" component={Pool} />
          <Route exact path="/deposit" component={AddLiquidity} />
          <Route exact path="/token" component={Token} />
          <Route exact path="/withdraw/:pairAddress" component={RemoveLiquidity} />
          <Redirect from="/" to="/swap" />
        </Switch>
      </>
    )
  }
}
